import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

/**
 * @param {string} purchaseOrderId - PO id
 * @param {string} [arqId] - Optional ARQ id for Advance Request attachments
 */
const getPoAttachmentsQuery = (purchaseOrderId, arqId) => {
  if (!purchaseOrderId) return Promise.resolve({ data: [] });
  const params = {
    purchaseOrderId,
    ...(purchaseOrderId && { poId: purchaseOrderId }),
    ...(arqId && { arqId })
  };
  return axios.get(apiurl?.getPoAttachments, { params });
};

const getPoAttachments = (purchaseOrderId, arqId = null, options = {}) => {
  const { enabled = !!purchaseOrderId } = options;
  return useQuery(
    ['getPoAttachments', purchaseOrderId, arqId],
    () => getPoAttachmentsQuery(purchaseOrderId, arqId),
    { enabled: !!purchaseOrderId && enabled, refetchOnWindowFocus: false }
  );
};

export default getPoAttachments;
export { getPoAttachmentsQuery };
